module.exports = __webpack_public_path__ + "static/img/cloud.496d5b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud.png
// module id = quBS
// module chunks = 19